module.exports = __webpack_public_path__ + "img/joinus-img.047b8960.jpg";